<template>
  <div>
    <div class="mx-auto w-full px-6 lg:px-4 py-8 place-items-center">
      <div class="mx-auto max-w-2xl lg:text-center">
        <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          <span v-if="agency">Never run out of content again</span>
          <span v-else>An abundance of user generated content to fill up your page and boost your sales</span>
        </p>
        <p class="mt-6 text-lg leading-8 text-gray-600">
          Consumers over 25 years old trust user-generated content 52% more than content created by brands.
        </p>
      </div>
      <div class="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] md:grid-cols-[repeat(auto-fit,minmax(257px,1fr))] mt-24 gap-3">
        <SocialContentPost v-for="post in posts" :key="post.thumbnail" :post="post"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import SocialContentPost from '@/pages/home/SocialContentPost.vue'
import { getFeaturedPosts } from '@/services/contentful/client'
import type { ContentfulFeaturedPost } from '@/services/contentful/types'

const props = withDefaults(defineProps<{agency: boolean}>(), {agency: false})

const posts = ref<ContentfulFeaturedPost[]>([])

onMounted(async () => {
  posts.value = await getFeaturedPosts()
})
</script>